import { createSelector } from 'reselect'

const getOnBoarding = state => state.get('persist').onBoarding

export const isLoading = createSelector(getOnBoarding, onBoarding => onBoarding.get('isLoading'))

export const selectedProTrackLevelId = createSelector(getOnBoarding, onBoarding =>
  onBoarding.get('selectedProTrackLevelId')
)
